import type { FC, PropsWithChildren } from "react";
import styled from "styled-components";

const LearnMoreButton = styled.a`
  background-color: transparent;
  color: white;
  padding: ${({ theme }) => theme.spacing(2.5, 4)};
  border-radius: ${({ theme }) => theme.borderRadius.xxl};
  border: 1px solid ${(props) => props.theme.colors.borderPrimary};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: #1e3a8a;
  }

  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`;

interface Props {
  href: string;
  onClick?: () => void;
}

export const SapphireLearnMoreButton: FC<PropsWithChildren<Props>> = ({ children, href, onClick }) => (
  <LearnMoreButton href={href} onClick={onClick}>
    {children}
  </LearnMoreButton>
);
